import { gql } from '@apollo/client/core';

export const PARENT_CARE_TYPE_QUERY = gql`
  query Parent {
    viewer {
      ... on Parent {
        careType
      }
    }
  }
`;

export const SITTER_COUNT_QUERY = gql`
  query ($careType: String!, $geoPointX: Decimal!, $geoPointY: Decimal!) {
    sitterSearch(searchParams: { careType: $careType, geoPoint: { x: $geoPointX, y: $geoPointY } }) {
      totalCount
    }
  }
`;

export const SITTER_PHOTO_QUERY = gql`
  query SitterPhoto($accountId: UUID!) {
    sitterAccount: account(id: $accountId) {
      ... on Sitter {
        id
        displayName
        photoUrl
      }
    }
  }
`;

export default SITTER_COUNT_QUERY;
